import React, { Children } from 'react';
import { ShimmerTitle } from 'react-shimmer-effects';

import './loading-text.scss';

export const LoadingText = ({
  loading = false,
  children,
  lines = 1,
  gap = 8,
  small = false,
  width = '100%',
  height = 24
}) => (
  <>
    {(children === 0 || children) && !loading ? (
      Children.count(children) > 1 ? (
        <>{children}</>
      ) : React.isValidElement(children) && children.type === 'div' ? (
        children
      ) : (
        <span>{children}</span>
      )
    ) : (
      <div className="loading-text" style={{ width: width, height: small ? 16 : height }}>
        <ShimmerTitle
          variant={small ? 'secondary' : 'primary'}
          line={lines}
          gap={gap}
          className="loading-text__shimmer"
        />
      </div>
    )}
  </>
);
